import React from 'react';

interface SidebarItem {
  id: string;
  label: string;
  icon: string;
}

interface AdminDesktopSidebarProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
  sidebarItems: SidebarItem[];
}

const AdminDesktopSidebar: React.FC<AdminDesktopSidebarProps> = ({
  activeTab,
  onTabChange,
  sidebarItems
}) => {
  return (
    <div className="admin-desktop-sidebar">
      <div className="admin-sidebar-header">
        <div className="admin-logo">
          <span className="admin-logo-icon">👑</span>
          <span className="admin-logo-text">Admin Panel</span>
        </div>
        <div className="admin-badge">SUPER ADMIN</div>
      </div>
      
      <nav className="admin-sidebar-nav">
        {sidebarItems.map(item => (
          <button
            key={item.id}
            className={`admin-nav-item ${activeTab === item.id ? 'active' : ''}`}
            onClick={() => onTabChange(item.id)}
          >
            <span className="admin-nav-icon">{item.icon}</span>
            <span className="admin-nav-label">{item.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default AdminDesktopSidebar;


